import { Icon, type IconName } from "../../icons";

export interface LinkCardProps {
  title: string;
  description?: string;
  icon: IconName;
  onClick: () => void;
}

export function LinkCard({ title, description, icon, onClick }: LinkCardProps): React.JSX.Element {
  return (
    <button type="button" className="nb-link-card" onClick={onClick}>
      <span className="nb-link-card-icon">
        <Icon name={icon} />
      </span>
      <span className="nb-link-card-text">
        <strong>{title}</strong>
        {description ? <span>{description}</span> : null}
      </span>
      <Icon name="chevronRight" />
    </button>
  );
}
